<template>
  <div class="rb-summary-option">
    <div class="rb-left">
      <div class="rb-summary-title">{{ summary.title }}</div>
      <div class="rb-summary-value" v-html="summaryValue"></div>
    </div>
    <div class="rb-left">
      <a
        href="#"
        @click.prevent="notifyEdit($event, summary)"
        :id="`edit-${summary.id}`"
        >Edit</a
      >
    </div>
  </div>
</template>
<script>
/**
 * Displays selected option in summary
 *
 * @props
 * summary: Object
 * selectedOptions: Array
 *
 * @implements
 * CommMixin
 * FormattersMixin
 * TrackMixin
 *
 * @emits
 * rb-step-edit
 */
import CommMixin from "@/mixins/CommMixin";
import TrackMixin from "@/mixins/TrackMixin";
import FormattersMixin from "@/mixins/FormattersMixin";
export default {
  mixins: [CommMixin, FormattersMixin, TrackMixin],
  props: {
    summary: {
      type: Object,
    },
    selectedOptions: {
      type: Array,
    },
  },
  computed: {
    summaryValue: function () {
      var selectedChoice = this.selectedOptions.find(
        (selectedOption) => selectedOption.step.id === this.summary.id
      )?.choice;
      if (!selectedChoice) return "-";
      // console.log(selectedChoice);
      if (this.summary.id === "engraving") {
        return selectedChoice.value;
      } else if (this.summary.id === "diamond") {
        return `<a href="${
          selectedChoice.cert_url
        }" target="_blank">GIA Certificate #${
          selectedChoice.cert_num
        }</a><br />Shape: ${
          selectedChoice.shape
        }<br />Carat: ${this.formatCarats(selectedChoice.size)}<br />Color: ${
          selectedChoice.color
        }<br />Clarity: ${selectedChoice.clarity}`;
      } else {
        return selectedChoice.labelDisplay
          ? selectedChoice.labelDisplay
          : selectedChoice.label;
      }
    },
  },
  methods: {
    notifyEdit: function (event, summary) {
      this.broadcast("rb-step-edit", summary);
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
    },
  },
};
</script>
